import React from "react";
import {Layout} from "antd";
import Header from "../components/headerComponent/header";
import Footer from "../components/footerComponent/footer";
import Wages from "../components/teacherComponent/wagesComponent";

export default function WagesPage() {
    return (
        <Layout>
            <Header/>
            <Wages/>
            <Footer/>
        </Layout>
    );
}